import { GetAppMetricsTotalSummaryWholeTeamQuery } from '../../../../../src/interface/queries/team-metrics/summary/get-app-metrics-total-summary-whole-team.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAppMetricsTotalSummaryWholeTeamRequestDto } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-total-summary-whole-team.request.dto';
import { GetAppMetricsTotalSummaryWholeTeamResponseArray } from '../../../../../src/interface/dtos/team-metrics/summary/get-app-metrics-total-summary-whole-team.response.dto';
import { AppMetricsTotalSummaryWholeTeamMapper } from '../../../../../src/infrastructure/mappers/team-metrics/summary/app-metrics-total-summary-whole-team.mapper';

export class GetAppMetricsTotalSummaryWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTotalSummaryWholeTeamQuery,
    protected readonly mapper: AppMetricsTotalSummaryWholeTeamMapper
  ) {}

  async get(
    props: GetAppMetricsTotalSummaryWholeTeamRequestDto
  ): Promise<GetAppMetricsTotalSummaryWholeTeamResponseArray> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `AppMetricsTotalSummaryWholeTeamController.get encountered an error: ${error}`
      );
    }
  }
}
